import { useState } from 'react';

type Props = {
  content: string;
  children: React.ReactNode;
  placement?: 'top' | 'bottom';
};

export function Tooltip({ content, children, placement = 'top' }: Props) {
  const [visible, setVisible] = useState(false);

  const isTop = placement === 'top';

  return (
    <div
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      {children}
      {visible && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            [isTop ? 'bottom' : 'top']: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            [isTop ? 'marginBottom' : 'marginTop']: 6,
            background: 'var(--warm-gray-900)',
            color: '#fff',
            fontSize: 'var(--text-xs)',
            lineHeight: 'var(--leading-normal)',
            padding: '5px 9px',
            borderRadius: 'var(--radius-sm)',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            zIndex: 20,
            boxShadow: 'var(--shadow-raised)',
          }}
        >
          {content}
        </span>
      )}
    </div>
  );
}
